/** Bảng chỉnh ngưỡng nhập hàng: ngưỡng chung + ghi đè từng món. */
import { useState } from 'preact/hooks';
import { layThamSo } from '../../core/du-lieu.js';
import { matHangMo, nguongNhap, tonKhoHienTai } from '../../core/kho.js';
import type { GameController } from '../game-controller.js';
import { styleNutPhu, stylePanel, useCapNhat } from '../dung-chung.js';

export function PanelNhapHang(props: { controller: GameController }) {
  const { controller } = props;
  useCapNhat(controller);
  const [nguongMoi, setNguongMoi] = useState('');
  const { state, duLieu } = controller;
  const macDinh = layThamSo(duLieu, 'P09');
  const monMo = matHangMo(state, duLieu);

  const luuChung = (): void => {
    const v = nguongMoi.trim();
    if (v === '') {
      controller.datNguongNhapChung(undefined);
    } else {
      const n = Number(v);
      if (!Number.isInteger(n) || n < 0) {
        alert('Ngưỡng phải là số nguyên ≥ 0, hoặc để trống để dùng mặc định.');
        return;
      }
      controller.datNguongNhapChung(n);
    }
    setNguongMoi('');
  };

  return (
    <div style={stylePanel}>
      <h3 style={{ margin: '0 0 8px' }}>📦 Ngưỡng nhập hàng</h3>
      <p style={{ fontSize: '12px', opacity: 0.85, margin: '0 0 8px' }}>
        Khi tồn kho xuống dưới ngưỡng, cửa hàng tự đặt hàng bù. Mặc định: {macDinh} món.
      </p>
      <div style={{ display: 'flex', gap: '6px', marginBottom: '10px' }}>
        <input
          value={nguongMoi}
          onInput={(e) => setNguongMoi((e.target as HTMLInputElement).value)}
          placeholder={`Chung (${state.nguongChung ?? macDinh})`}
          inputMode="numeric"
          style={{
            width: '110px',
            padding: '6px',
            borderRadius: '6px',
            border: '1px solid #8a6a3a',
          }}
        />
        <button onClick={luuChung} style={styleNutPhu}>
          Đặt
        </button>
        <button
          onClick={() => controller.datNguongNhapChung(undefined)}
          style={styleNutPhu}
          title="Về mặc định"
        >
          ↺
        </button>
      </div>
      <div style={{ maxHeight: '220px', overflowY: 'auto' }}>
        {monMo.map((m) => (
          <div
            key={m.ma}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              padding: '4px 0',
              borderBottom: '1px solid rgba(138,106,58,0.3)',
              fontSize: '13px',
            }}
          >
            <span style={{ flex: 1 }}>
              {m.ten} <span style={{ opacity: 0.7 }}>(tồn {tonKhoHienTai(m.ma, state)})</span>
            </span>
            <input
              value={state.nguongRieng[m.ma] ?? ''}
              placeholder={String(nguongNhap(m.ma, state, duLieu))}
              inputMode="numeric"
              title={`Ngưỡng riêng cho ${m.ten} — để trống để dùng ngưỡng chung`}
              onChange={(e) => {
                const v = (e.target as HTMLInputElement).value.trim();
                try {
                  if (v === '') controller.datNguongNhapRieng(m.ma, undefined);
                  else {
                    const n = Number(v);
                    if (!Number.isInteger(n) || n < 0) throw new Error('sai');
                    controller.datNguongNhapRieng(m.ma, n);
                  }
                } catch {
                  alert('Ngưỡng phải là số nguyên ≥ 0.');
                }
              }}
              style={{
                width: '52px',
                padding: '4px',
                borderRadius: '6px',
                border: '1px solid #8a6a3a',
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
